(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  const initFilters = () => {
    const filterModal = document.getElementById('filter-modal');
    const filterOverlay = document.getElementById('filter-overlay');
    const productCountContainer = document.querySelector('.collection-product-count');

    // Toggle Modal
    const toggleModal = () => {
      if (!filterModal) return;
      filterModal.classList.toggle('is-open');
      if (filterOverlay) filterOverlay.classList.toggle('is-visible');
      document.body.classList.toggle('overflow-hidden');
    };

    // Use event delegation for toggles and close buttons
    document.addEventListener('click', (e) => {
      // Toggle button (icon)
      if (e.target.closest('.collection-filter-toggle')) {
        toggleModal();
      }

      // Close button in modal
      if (e.target.closest('.filter-modal__close')) {
        toggleModal();
      }

      // Overlay click
      if (e.target === filterOverlay) {
        toggleModal();
      }

      // Accordion Logic
      const header = e.target.closest('.filter-group__header');
      if (header) {
        header.closest('.filter-group').classList.toggle('is-collapsed');
      }
    });

    // AJAX Filtering
    const fetchContent = async (url) => {
      try {
        const response = await fetch(url);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newGrid = doc.getElementById('product-grid');
        const grid = document.getElementById('product-grid');
        if (newGrid && grid) {
          grid.innerHTML = newGrid.innerHTML;
          bindLoadMore();
        }

        const newForm = doc.getElementById('filter-form');
        const form = document.getElementById('filter-form');
        if (newForm && form) {
          form.innerHTML = newForm.innerHTML;
        }

        const newCount = doc.querySelector('.collection-product-count');
        if (newCount && productCountContainer) {
          productCountContainer.innerHTML = newCount.innerHTML;
        }

        history.pushState({ url }, '', url);
      } catch (error) {
        console.error('Error fetching collection content:', error);
      }
    };

    document.addEventListener('submit', (e) => {
      if (e.target.id === 'filter-form') {
        e.preventDefault();
        const formData = new FormData(e.target);

        // Ensure parameters are appended correctly
        const searchParams = new URLSearchParams();
        for (const [key, value] of formData.entries()) {
          if (value) searchParams.append(key, value);
        }

        const url = `${window.location.pathname}?${searchParams.toString()}`;
        fetchContent(url);
        toggleModal();
      }
    });

    // Load More Functionality
    const bindLoadMore = () => {
      const loadMoreBtn = document.getElementById('load-more-button');
      if (loadMoreBtn) {
        // Clone to remove old listeners
        const newBtn = loadMoreBtn.cloneNode(true);
        loadMoreBtn.parentNode.replaceChild(newBtn, loadMoreBtn);

        newBtn.addEventListener('click', async (e) => {
          e.preventDefault();
          const url = newBtn.getAttribute('data-url');

          newBtn.disabled = true;
          newBtn.innerText = 'Завантаження...';

          try {
            const response = await fetch(url);
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const newProducts = doc.querySelectorAll('.product-card');
            const grid = document.getElementById('product-grid');

            newProducts.forEach((product) => {
              grid.insertBefore(product, grid.querySelector('.collection-load-more'));
            });

            const newNextUrl = doc.querySelector('#load-more-button')?.getAttribute('data-url');
            if (newNextUrl) {
              newBtn.setAttribute('data-url', newNextUrl);
              newBtn.disabled = false;
              newBtn.innerText = 'Показати більше товарів';
            } else {
              newBtn.parentElement.remove();
            }
          } catch (error) {
            console.error('Error loading more products:', error);
            newBtn.disabled = false;
            newBtn.innerText = 'Показати більше товарів';
          }
        });
      }
    };

    bindLoadMore();

    // Handle back/forward buttons
    window.addEventListener('popstate', (e) => {
      if (e.state && e.state.url) {
        fetchContent(e.state.url);
      } else {
        fetchContent(window.location.href);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilters);
  } else {
    initFilters();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const toggle = document.querySelector('.header__menu-toggle');
    const menu = document.getElementById('mobile-menu');

    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !isExpanded);
      menu.setAttribute('aria-hidden', isExpanded);
      document.body.style.overflow = isExpanded ? '' : 'hidden';
    });

    // Close menu when clicking a link
    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        toggle.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
